// Hook para verificar permissões
import { useAuth } from '@/context/AuthContext';

// Mapeamento de rotas para permissões necessárias (usando underscore)
export const ROUTE_PERMISSIONS = {
  '/': [], // Dashboard - todos podem ver
  '/pdv': ['PDV_VIEW'],
  '/salao': ['PDV_VIEW'],
  '/venda-rapida': ['PDV_VIEW'],
  '/orders': ['PEDIDOS_VIEW'],
  '/delivery': ['DELIVERY_VIEW'],
  '/delivery/management': ['DELIVERY_VIEW'],
  '/kds': ['KDS_VIEW'],
  '/products': ['PRODUTOS_VIEW'],
  '/categories': ['PRODUTOS_VIEW'],
  '/customers': ['CLIENTES_VIEW'],
  '/stock': ['ESTOQUE_VIEW'],
  '/finance': ['FINANCEIRO_VIEW'],
  '/fiscal': ['FISCAL_VIEW'],
  '/sefaz': ['FISCAL_VIEW'],
  '/cash': ['FINANCEIRO_VIEW'],
  '/reports': ['RELATORIOS_VIEW'],
  '/bot': ['CONFIGURACOES_VIEW'],
  '/bot/config': ['CONFIGURACOES_VIEW'],
  '/bot/conversas': ['CONFIGURACOES_VIEW'],
  '/bot/whatsapp': ['CONFIGURACOES_VIEW'],
  '/bot/mensagens': ['CONFIGURACOES_VIEW'],
  '/bot/fluxos': ['CONFIGURACOES_VIEW'],
  '/bot/webhooks': ['CONFIGURACOES_VIEW'],
  '/bot/logs': ['CONFIGURACOES_VIEW'],
  '/crm': ['CRM_VIEW'],
  '/heatmap': ['CRM_VIEW'],
  '/analytics': ['CRM_VIEW'],
  '/routing': ['DELIVERY_VIEW'],
  '/drivers': ['DELIVERY_VIEW'],
  '/driver-settlements': ['DELIVERY_VIEW'],
  '/cod-finance': ['FINANCEIRO_VIEW'],
  '/digital-menu': ['CONFIGURACOES_VIEW'],
  '/rbac': ['USUARIOS_VIEW'],
  '/ifood': ['IFOOD_VIEW'],
  '/99food-v4': ['IFOOD_VIEW'],
  '/keeta': ['IFOOD_VIEW'],
  '/keeta-ops': ['IFOOD_VIEW'],
  '/printer-settings': ['CONFIGURACOES_VIEW'],
  '/settings': ['CONFIGURACOES_VIEW'],
};

export function usePermissions() {
  const { user } = useAuth();
  
  const hasPermission = (permission) => {
    if (!user) return false;
    // Admin Master tem todas as permissões
    if (user.role === 'ADMIN_MASTER') return true;
    // Verificar se o usuário tem a permissão
    return user.permissions?.includes(permission) || false;
  };
  
  const hasAnyPermission = (permissions) => {
    if (!user) return false;
    if (user.role === 'ADMIN_MASTER') return true;
    if (!permissions || permissions.length === 0) return true;
    return permissions.some(p => user.permissions?.includes(p));
  };
  
  const canAccessRoute = (path) => {
    const requiredPerms = ROUTE_PERMISSIONS[path];
    if (!requiredPerms || requiredPerms.length === 0) return true;
    return hasAnyPermission(requiredPerms);
  };
  
  return { hasPermission, hasAnyPermission, canAccessRoute };
}
